'use client';

import { useQuery } from 'src/shared/lib/useQuery';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { InternalNote } from 'src/shared/types/internalNote.types';
import { QueryResult } from 'src/shared/types/util.types';

export function getInternalNotesQueryKey(orgId: string, integrationId: string, threadId: string) {
  return ['internal-notes', genQueryKey(orgId, integrationId, threadId)];
}

export function useInternalNotes(integrationId?: string, threadId?: string): QueryResult<InternalNote[]> {
  const { orgFetch, currentOrg } = useOrg();

  return useQuery({
    queryKey: getInternalNotesQueryKey(currentOrg.id, integrationId!, threadId!),
    queryFn: async () => {
      const res = await orgFetch<InternalNote[]>(
        `/api/v2/internal-notes?integrationId=${integrationId}&threadId=${threadId}`
      );

      if (!res.ok) {
        throw new Error('Failed to fetch internal notes');
      }

      return res.json();
    },
    enabled: !!integrationId && !!threadId,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}
